interface UrlParams {
  courseId: UUID;
  meetingId?: UUID;
  page?: string;
}

const baseUrl = (params: Pick<UrlParams, 'courseId'>) => `/manage/courses/${params.courseId}`;

/**
 * Create a meeting URL with the parameters populated.
 */
export const meetingUrl = (params: UrlParams) =>
  `${baseUrl(params)}/meetings/${params.meetingId ? params.meetingId + '/' : ''}${
    params.page || ''
  }`;

interface SeriesUrlParams {
  courseId: UUID;
  seriesId: UUID;
}

export function seriesUrl(params: SeriesUrlParams) {
  return `${baseUrl(params)}/meetings/series/${params.seriesId}`;
}
